import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { firmsAction } from 'common/actions';
import { useStore } from 'common/store';
import { LayoutContextValues, UseStoreValues } from 'common/types/store';
import LayoutContext from 'context/LayoutContext';
import { useCompanyDashboardContext } from 'dashboard409a/context/CompanyDashboardContext/CompanyDashboardContext';
import { updateUserState } from 'dashboard409a/states/features/user/userSlice';
import { AppDispatchType, RootStateType } from 'dashboard409a/states/store';
import UserProfile from 'pages/UserProfile/UserProfile';

const AccountSettings = () => {
  const { updatePageActions } = useCompanyDashboardContext();
  const [, dispatch] = useStore() as unknown as UseStoreValues;
  const reduxDispatch = useDispatch<AppDispatchType>();
  const reduxUser = useSelector((state: RootStateType) => state.user);

  useEffect(() => {
    const firmId = reduxUser?.firms_permissions?.[0]?.id;
    if (firmId) {
      dispatch(firmsAction.setFirmId(firmId));
    }
  }, [reduxUser, dispatch]);

  const handleSaveSuccess = useCallback(
    (response: unknown) => {
      const updatedUser = response as typeof reduxUser;
      if (updatedUser?.profile?.picture_url) {
        reduxDispatch(updateUserState({ ...reduxUser, profile: { ...reduxUser.profile, picture_url: updatedUser.profile.picture_url } }));
      }
    },
    [reduxDispatch, reduxUser]
  );

  const layoutContextValue = useMemo(
    () => ({ setPageActions: updatePageActions as unknown as LayoutContextValues['setPageActions'] }),
    [updatePageActions]
  );

  return (
    <LayoutContext.Provider value={layoutContextValue as never}>
      <UserProfile onSaveSuccess={handleSaveSuccess} />
    </LayoutContext.Provider>
  );
};

export default AccountSettings;
